import { notEmptyString } from "./validators";

export default { 
    shortenUrl(val) {
      let str = "";
      if (notEmptyString(val)) {
        str = val.replace(/^\w+:\/\//, "");
      }
      return str;
    },
    yesNo(val) {
      return val ? "Yes" : "No";
    },
}